import React from 'react';
import './styles/UserProfile.css';
import { ArrowLeft } from '@icon-park/react';
import { useUserProfile } from './hooks/useUserProfile';
import { ProfileSidebar } from './components/ProfileSidebar';
import { ProfileInfo } from './components/ProfileInfo';
import { ProfileEdit } from './components/ProfileEdit';
import { LabelList } from './components/LabelList';

/**
 * UserProfile - 用户个人中心主组件
 */
function UserProfile({
  user,
  isLoading,
  onClose,
  onLogout,
  onCreateLabel,
  onEditLabel,
  onProfileUpdated,
  onRefreshUser,
}) {
  // 使用自定义 Hook 管理状态和逻辑
  const {
    activeTab,
    setActiveTab,
    profileData,
    editData,
    feedback,
    isSaving,
    handleEditChange,
    resetEditForm,
    handleSubmit,
  } = useUserProfile(user, onProfileUpdated, onRefreshUser);

  // 返回按钮处理
  const handleBackClick = (event) => {
    event.preventDefault();
    onClose && onClose();
  };

  // 升级/创建标签处理
  const handleUpgrade = (event) => {
    if (event) {
      event.preventDefault();
    }
    // 显示升级提示，而不是跳转到创建标签页面
    alert('企业会员升级功能即将上线，敬请期待！\n\n如需升级为企业会员，请联系客服：029-81330339 或邮箱 service@huapubio.net');
  };

  // Loading 状态
  if (isLoading) {
    return (
      <div className="user-profile-page">
        <div className="profile-loading">正在加载个人中心...</div>
      </div>
    );
  }

  // 错误状态
  if (!profileData) {
    return (
      <div className="user-profile-page">
        <div className="profile-error">未获取到用户信息，请重新登录。</div>
      </div>
    );
  }

  return (
    <div className="user-profile-page">
      {/* 锚点 */}
      <span id="home" className="profile-anchor" aria-hidden="true"></span>
      <span id="features" className="profile-anchor" aria-hidden="true"></span>
      <span id="workflow" className="profile-anchor" aria-hidden="true"></span>
      <span id="knowledge" className="profile-anchor" aria-hidden="true"></span>
      <span id="news" className="profile-anchor" aria-hidden="true"></span>
      
      <div className="profile-container">
        {/* 面包屑导航 */}
        <div className="breadcrumb">
          <a href="#" onClick={handleBackClick}>
            <ArrowLeft theme="outline" size={16} fill="#333" strokeWidth={3} /> 返回
          </a>
          <span className="breadcrumb-separator">首页 &gt; 个人中心</span>
        </div>

        <div className="profile-content">
          {/* 左侧边栏 */}
          <ProfileSidebar
            username={profileData.username}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            onLogout={onLogout}
          />

          {/* 右侧主内容区 */}
          <main className="profile-main">
            {activeTab === 'profile' ? (
              <ProfileInfo 
                profileData={profileData} 
                onUpgrade={handleUpgrade} 
              />
            ) : activeTab === 'myLabels' ? (
              <LabelList 
                onCreateLabel={onCreateLabel}
                onEditLabel={onEditLabel}
              />
            ) : (
              <ProfileEdit
                editData={editData}
                feedback={feedback}
                isSaving={isSaving}
                onEditChange={handleEditChange}
                onSubmit={handleSubmit}
                onReset={resetEditForm}
              />
            )}
          </main>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
